'use client'

import CompanyBlocker from '@/app/[lng]/components/BlockerModal/CompanyBlocker'
import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import { useTranslation } from '@/app/i18n/client'
import { Skeleton } from '@/components/ui/skeleton'
import { getCompanyProfileData } from '@/services/companyDetailsService'
import Image from 'next/image'
import { useParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import {
  CompanyProfileData,
  Product,
} from '../../../../../types/companyProfileTypes'
import LogisticsCard from '../../../fruits_and_vegetables/[id]/product_service/LogisticsCard'
import { RootState } from '@/app/globalRedux/store'
import { useSelector } from 'react-redux'

const ProductAndServicesComponent = () => {
  const { t } = useTranslation()
  const params = useParams()
  const { access_count, isBeneficiary,accessPer } = useSelector(
    (state: RootState) => state.user
  )
  const [showContent, setShowContent] = useState<boolean | null>(null)
  const [products, setProducts] = useState<Product[] | []>([])
  const [isloading, setIsloading] = useState(false)
  const fetchData = async () => {
    setIsloading(true)
    const response: CompanyProfileData = await getCompanyProfileData(params.id)
    if (response?.message === 'Access Exhausted') {
      setShowContent(false)
    } else if (response?.status == 'success') {
      setShowContent(true)
      setProducts(response.products)
    }
    setIsloading(false)
  }
  useEffect(() => {
    fetchData()
  }, [])
  if (showContent === null) {
    return <Skeleton className="w-[952px] h-[500px]" />
  }
  return (
    <main>
      {!showContent && (
        <CompanyBlocker
          access_count={access_count}
          isBeneficiary={isBeneficiary}
          accessPer={accessPer}
        />
      )}
      <div className="w-[952px] shadow-[0_0_6px_0_rgba(0,0,0,0.16)] rounded-[5px] mt-[28px] mobile-width">
        <div className=" px-[25px] py-[20px] text-base font-ns_bold border-b border-solid border-[#eaeaea] mobile:py-[10px]">
          {t('Our Products')}
        </div>
        <div className="mx-[25px] grid grid-cols-[auto_auto] !p-6">
          <ul className="text-sm text-[#666666] leading-[1.75] list-disc">
            {products?.length > 0 &&
              products?.map((product, index) => (
                <CustomErrorBoundary key={`${index}cuserr`}>
                  <li>{product?.name}</li>
                </CustomErrorBoundary>
              ))}
          </ul>
        </div>
        {!isloading && products?.length === 0 && (
          <div className="p-16 flex flex-col gap-2 items-center justify-center text-primary-foreground">
            <Image
              loading="lazy"
              width={86}
              height={94}
              src="/assets/Icons/noImage/noProductIcon.svg"
              alt=""
              className="w-[85px] h-[94px] object-cover"
            />
            <div className="flex">{t('Product & service not available')}</div>
          </div>
        )}
      </div>
      <div>
        <LogisticsCard title={'Coverage Area'} />
      </div>
    </main>
  )
}

export default ProductAndServicesComponent
